import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import useModal from "@hooks/ModalHook";
import { ShareInputs } from "@components/ShareInputs";
import { useApi } from "@hooks/ApiHook";
import useAlert from "@hooks/AlertHook";
import { useWasmX } from "@hooks/WasmXHook";
import { ShareRequest } from "wasmx";
import { useTxModal } from "@hooks/TxModalHook";
import { CollectionResponse } from "baaanggg";
import { TxInfo } from "@terra-money/terra.js";

type Props = {
    collection: CollectionResponse,
    onSaved: () => void
}

function TxSharesModal({ onSaved, collection: { collectionContract, id, ownerAddress } }: Props) {
    const { showModal, closeModal, modalId } = useModal()
    const { data } = useApi(api => api.collection.txShares(id), [id])
    const [shares, setShares] = useState<{ [key: string]: number; }>({})
    const alert = useAlert()
    const wasmX = useWasmX()
    const txModal = useTxModal()

    useEffect(() => setShares(data?.reduce((prev, curr) => ({ ...prev, [curr.address]: curr.percentage * 100 }), {}) ?? {}), [data])


    const onSubmit = async () => {
        closeModal()

        try {
            if (!wasmX) throw new Error("Cannot get information from blockchain, try refresh the page")

            const message = wasmX.collection.execute.setTxShares({
                contract: collectionContract,
                sender: ownerAddress,
                data: {
                    shares: Object.entries(shares).map<ShareRequest>(([address, percentage]) => ({ address, percentage: (percentage / 100).toString() }))
                }
            })

            await new Promise<TxInfo>((onSuccess, onError) => txModal.show(ownerAddress, [message], "Update Tx Shares", {
                onSuccess,
                onError
            }))
            onSaved()
        } catch (e) {
            if (e instanceof Error) alert.failed(e.message)
        }
    }

    return (
        <>
            <Modal show={showModal && modalId === "tx-shares"} dialogClassName="max-w-3xl">
                <Modal.Header >
                    <Modal.Title>Transaction Shares</Modal.Title>
                    <button type="button" className="btn-close" onClick={() => closeModal()} aria-label="Close">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="24"
                            height="24"
                            className="h-6 w-6 fill-jacarta-700 dark:fill-white"
                        >
                            <path fill="none" d="M0 0h24v24H0z" />
                            <path
                                d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z"
                            />
                        </svg>
                    </button>
                </Modal.Header>
                <Modal.Body className="p-6">
                    <div>
                        <label className="block mb-1 font-display text-sm text-jacarta-700 dark:text-white">Tx Shares</label>
                        <ShareInputs shares={shares} creator={ownerAddress} onChange={shares => setShares(shares)} />
                    </div>

                    <button
                        onClick={onSubmit}
                        className="rounded-full ml-auto mt-5 bg-accent py-3 px-8 text-center font-semibold text-white shadow-accent-volume transition-all hover:bg-accent-dark"
                    >
                        Update
                    </button>
                </Modal.Body>
            </Modal >
        </>
    )
}

export default TxSharesModal;